import { Box, Grid } from '@mui/material';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { url } from '../../../../configlink';
import { useSelector } from 'react-redux';

const InvoiceView = () => {
    let loc = useLocation();
    let orderNum = parseInt(loc.search.split("&")[0].split('=')[1]) + 600000;
    
	let adminUser = useSelector((state) => state.userAdmin.userAdmin)
    // const token = localStorage.getItem("token");

    let [files, setFiles] = useState([])
    let [userId, setUserId] = useState()

    useEffect(() => {
      getData()
    },[])

    function getData(){
      try {
        fetch(`${url}/api/admin/get_userid_by_orderid?orderId=${orderNum}`,{
          method: 'GET',
			credentials: 'include',
			headers: {
				'acgt-admin': adminUser
			},
        })
        .then(res => res.json())
        .then(data => {
          console.log(data);
          setUserId(data.UserId)

          if(data.UserId){
            fetch(`${url}/api/admin/get_invoice_filenames_by_orderid?orderId=${orderNum}`,{
              method: 'GET',
				credentials: 'include',
				headers: {
					'acgt-admin': adminUser
				},
            })
              .then(response => response.json())
              .then(data => {
                console.log(data);
              
                setFiles(data)
              })
              .catch(error => console.error('Error fetching files:', error));
          }
        })
        .catch(err => console.error(err))
      } catch (error) {
        console.error(error)
      }
    }

    
    console.log(userId);
    console.log(files);

    const columns = [
      {
        field: "InvoiceFiles",
        headerName: "Invoice Name",
        type: "string",
        width: 150,
        editable: false,
      },
      {
        field: "UploadDate",
        headerName: "Upload Date",
        type: "string",
        width: 175,
        editable: false,
        // valueFormatter: ({ value }) => {
        //   return value ? value.split('T')[0] : '';
        // },
      },
      {
        field: "actions",
        type: "actions",
        headerName: "",
        width: 5,
        cellClassName: "actions",
        getActions: ({ id }) => {
          return [
            <GridActionsCellItem
              icon={<DeleteIcon />}
              // onClick={() => console.log(id)}
              onClick={() => disableInvoice(id)}
              label="Edit"
              className="textPrimary"
              color="inherit"
              style={{position:'relative', left:'10px'}}
              key={id}
            />,
          ];
        },
      }
    ];

    function disableInvoice(x){
      let conf = window.confirm("Disable invoice?")

      if(conf){
        try {
          fetch(`${url}/api/admin/disable_invoice?id=${x}`,{
            method:"PUT",
			credentials: 'include',
			headers: {
				'acgt-admin': adminUser
			},
          })
          .then(res => res.json())
          .then(data => {
            if(data.message === 'success'){
              alert("Success")
              getData()
            }
          })
          .catch(err => console.error(err))
        } catch (error) {
          console.error(error)
        }
      }
    }
    


  return (
    <div className='flex flex-col justify-start items-center mt-10'>
        <div className='flex flex-col items-center w-3/4 h-auto'>
            <h1 className="text-lg font-extrabold text-[var(--color-primary-purple)]">Invoice for Order Number #{orderNum}</h1>
            <div className='border-1 border-black mt-5 min-h-[150px] w-full'>
                <div className='text-center'>
                    {files && files.length>0 ? (
                    <Grid container style={{ justifyContent: 'center', width:'100%' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', height: '550px', width:'100%' }}>
                          <DataGrid
                            pagination
                            autoPageSize
                            style={{ width: '100%', height: '100%', padding: '20px' }}
                            columnHeaderHeight={30}
                            rowHeight={30}
                            rows={files}
                            columns={columns}
                            sx={{
                              '& .MuiDataGrid-columnHeaders': {
                                color: 'var(--color-primary-purple)'
                              },
                              '& .MuiDataGrid-columnHeaderTitle': {
                                fontWeight: 700,
                              },
                            }}
                          />
                        </div>
                    </Grid>
                  ) : (
                        <h1 className='text-red-500 text-sm'>No files to download</h1>
                    )
                    }
                </div>
            </div>
        </div>

        <button onClick={() => window.close()} className='text-sm mt-10 w-[130px] text-center text-[var(--color-primary-purple)] p-1 rounded-md font-bold bg-gray-200'>Close Window</button>    
        
    </div>
  )
}

export default InvoiceView